/* BTOCSITE-40437 PLP 스크립트 start */
$(document).ready(function(){
	if(!document.querySelector('.isLaptap')) return false;
	laptapOpt();
});

function laptapOpt(){
	console.log('laptapOpt Init');

	var delAttrId = "";

	var isLaptap = $('.KRP0007.isLaptap');
	var laptapListWrap = isLaptap.find('.laptap-opt-list-wrap');
	var laptapList = laptapListWrap.find('.laptap-opt-list');
	var filterChoice = isLaptap.find('.plp-afilter-choice');
	var filterChoiceItem = filterChoice.find('.choice-item');
	var resetBtn = isLaptap.find('.laptap-opt-list-wrap .item-reset')

	// 초기화시 기존 필터 선택 영역 있으면 초기화
	if( laptapList.find('.opt-list >li').length > 0 ){
		laptapList.find('.opt-list >li').remove();
		laptapListWrap.hide();
	}

	setTimeout(function(){
		var ui_sticky_h = isLaptap.find('.ui_sticky').height();
		isLaptap.find('.ui_sticky').parent('div').css('height', ui_sticky_h);
	},500)

	// 옵션 플렉서블 개발을 위한 width 정의
	function optWidth() {
		filterChoiceItem.each(function(){
			setTimeout(function(){
				var optWitdh = isLaptap.find('.opt').innerWidth();
				var filterWrap = isLaptap.find('.choice-filter-wrap');
				filterWrap.css('width', 'calc(100% -'+optWitdh+'px');
				
				var optW = $(window).width() - optWitdh;
				filterWrap.css('max-width', optW);
				filterWrap.css('width', optW);
			},500)
		})
	}

	$(window).resize(function(){
		optWidth();
	});

	optWidth();

	// 옵션 change시 show/hide로 인한 sticky 높이값 정의
	function optChange() {
		//console.log('_________KRP0007-3.0.0.js > optChange');
		if( laptapList.find('.opt-list >li').length == 0 ){
			laptapListWrap.hide();

			var ui_sticky_h = isLaptap.find('.ui_sticky').height();
			isLaptap.find('.ui_sticky').parent('div').css('height', ui_sticky_h);
		} else{
			laptapListWrap.show();

			var ui_sticky_h = isLaptap.find('.ui_sticky').height();
			isLaptap.find('.ui_sticky').parent('div').css('height', ui_sticky_h);
		}

		var hasOn = $(this).hasClass('on');

	}

	// 활성화된 옵션 X 버튼 클릭 event
	function optDel() {

		laptapList.find('button').each(function(){

			$(this).on('click', function(){

				//console.log('_________KRP0007-3.0.0.js > find > optDel');

				var optId = $(this).parents('li').attr('data-id');

				//s: BTOCSITE-55480  노트북 PLP 개선 : 삭제 후 데이터 재로딩 추가
				var _hasClass = filterChoiceItem.find('button[id='+ optId +']').hasClass('on')
				//e: BTOCSITE-55480  노트북 PLP 개선 : 삭제 후 데이터 재로딩 추가

				var laptapListCnt = laptapList.find('.opt-list >li').length

				laptapList.find('.opt-list >li[data-id='+ optId +']').remove();
				filterChoiceItem.find('button[id='+ optId +']').removeClass('on');
				isLaptap.find('.product-list-top .check-item input[id='+ optId +']').prop('checked', false);

				if( laptapList.find('.opt-list >li').length == 0 ){
					var ui_sticky_h = isLaptap.find('.ui_sticky').height();
					isLaptap.find('.ui_sticky').parent('div').css('height', ui_sticky_h);
				}

				//s: BTOCSITE-55480  노트북 PLP 개선 : 삭제 후 데이터 재로딩 추가
				var filterId = optId.replaceAll('quick_', '');

				optChange();

				if (filterId.indexOf('chk_product_')  < 0 ) { // 다품목 등등
					if(laptapListCnt > 0){
						$('#' + filterId).trigger('click');
					}
				}else if(_hasClass){
					$('#' + filterId).trigger('click');
				}

				//e: BTOCSITE-55480  노트북 PLP 개선 : 삭제 후 데이터 재로딩 추가
				return false;
			})
		});
	}

	// 활성화된 옵션 reset 버튼 클릭 event
	function optReset() {
		//console.log('_________KRP0007-3.0.0.js > optReset');
		resetBtn.find('button').on('click', function(){
			filterChoiceItem.find('button').removeClass('on');
			laptapList.find('.opt-list >li').remove();
			isLaptap.find('.product-list-top .check-item input').prop('checked', false);

			//$('.btn-refresh').trigger('click');

			optChange();
		});
	}

	var cnt = 0;
	// 체크필터 옵션 click event
	filterChoiceItem.find('button').each(function(){
		$(this).on('click', function(){
			//console.log('______________ filterChoiceItem');

			// 기본 필터 인경우 같은 class 사용히여 예외 처리
			var mobileMultiFilterFlag =  $('#mobileMultiFilterFlag').val()
			if(mobileMultiFilterFlag != 'Y'){
				return;
			}

			var clickOptTxt = $(this).text();
			var clickOptId = $(this).attr('id');

			//클래스는 갖고 있지만 선택 영역에 없으면 추가
			if($('#add_'+clickOptId).text() == '' || $('#add_'+clickOptId).text() == "undefined"){
				$(this).removeClass('on');
			}

			if( $(this).hasClass('on') ){
				$(this).removeClass('on');

				laptapList.find('.opt-list >li[data-id='+ clickOptId +']').remove();

				var ui_sticky_h = isLaptap.find('.ui_sticky').height();
				isLaptap.find('.ui_sticky').parent('div').css('height', ui_sticky_h);

			} else{
				// 두 번 그리는거 방지
				if($('#add_'+clickOptId).text() == clickOptTxt){
					return;
				}

				//오류 방어 코드 추가
				if(clickOptTxt == '초기화'){
					return;
				}

				$(this).addClass('on');
				//laptapList.find('.opt-list').append('<li data-id="' + clickOptId + '"><div class="s-fliter"><span id="add_'+clickOptId+'">' + clickOptTxt + '</span><button type="button" data-value="' + clickOptTxt + '"class="btn-del delete-content" style="pointer-events: auto;"><span class="blind">삭제</span></button></div></li>');
				laptapList.find('.opt-list').prepend('<li data-id="' + clickOptId + '"><div class="s-fliter"><span id="add_'+clickOptId+'">' + clickOptTxt + '</span><button type="button" data-value="' + clickOptTxt + '"class="btn-del delete-content" style="pointer-events: auto;"><span class="blind">삭제</span></button></div></li>');

				var ui_sticky_h = isLaptap.find('.ui_sticky').height();
				isLaptap.find('.ui_sticky').parent('div').css('height', ui_sticky_h);
			}

			if(cnt < 1){
				//console.log('cnt_____1st' , cnt);
				optReset(); // 활성화된 옵션 reset 버튼 클릭 event
			}

			optDel(); // 활성화된 옵션 X 버튼 클릭 event
			optChange(); // 옵션 change시 show/hide로 인한 sticky 높이값 정의

			cnt++;

		})
	});

	var last_scrollTop = 0;
	function filterScrollDirectionCheck() {
		if(!document.querySelector('.isLaptap')) {
			isLaptap.find('.product-list-top').removeAttr("style");
			return false;
		}
		console.log("window.innerWidth : " + window.innerWidth);
		if(window.innerWidth < 768){
			var tmp = $(window).scrollTop();

			if( isLaptap.find('.cate-wrap').hasClass('fixed') === true ){
				var m_nav_h = $('.header').outerHeight(); //46
				var cate_tab_h = $('.cate-list').outerHeight(); //54
				var nav_tab_h = m_nav_h + cate_tab_h; //100
				var opt_list_h = $('.laptap-opt-list-wrap').outerHeight(); //47
				var pd_list_h = $('.product-list-top').outerHeight(); //46

				isLaptap.find('.product-list-top').css({
					"position": "fixed",
					"top": "0",
					"left": "0",
					"width": "100%",
					"height": pd_list_h + "px",
					"border-bottom": "1px solid #ddd",
					"background": "#fff",
					"transition": "background .6s ease,box-shadow .6s ease,top .6s ease",
					"z-index": "5"
				});

				//is-scroll-down
				if ( tmp > last_scrollTop ) {
					//console.log('is-scroll-down');

					// 활성화된 옵션 X 버튼 클릭으로 인해 활성화된 옵션이 0개일 경우 / reset 버튼 클릭 event
					isLaptap.find('.s-fliter .btn-del, .laptap-opt-list-wrap .item-reset').on('click', function(){
						if( isLaptap.find('.opt-list > li').length == 0 ) {
							isLaptap.find('.product-list-top').css({
								"top": "0"
							});
						}
					})
					
					if( $('.plp-new-section').css('display') == 'none' ) {
						// 라인업 카드일 경우
						isLaptap.find('.cate-wrap').addClass('lineup-cate');
						// 체크된 옵션이 없는 경우
						if( laptapList.find('.opt-list >li').length == 0 ){
							laptapListWrap.hide();

							isLaptap.find('.product-list-top').css({
								"top": "0"
							});
						} else{
							laptapListWrap.show();

							isLaptap.find('.product-list-top').css({
								"top": opt_list_h + "px",
								"transition": "background .6s ease,box-shadow .6s ease,top .1s ease"
							});
						}
					} else {
						// 체크된 옵션이 없는 경우
						if( laptapList.find('.opt-list >li').length == 0 ){
							laptapListWrap.hide();
						} else{
							laptapListWrap.show();

							isLaptap.find('.product-list-top').css({
								"top": opt_list_h + "px"
							});
						}
						
						/* BTOCSITE-63911 멀티필터일 경우 스크롤 다운 시 안보이도록 시작 */
						if( isLaptap.find('.plp-afilter-choice').height() > 100 ) {
							isLaptap.find('.plp-afilter-choice').hide();
						}
						/* BTOCSITE-63911 멀티필터일 경우 스크롤 다운 시 안보이도록 끝 */
					}
				} else if( tmp < last_scrollTop ){ //is-scroll-up
					//console.log('is-scroll-up');

					if( $('.plp-new-section').css('display') == 'none' ) {
						// 라인업 카드일 경우
						// 체크된 옵션이 없는 경우
						if( laptapList.find('.opt-list >li').length == 0 ){
							laptapListWrap.hide();

							isLaptap.find('.product-list-top').css({
								"top": m_nav_h + "px"
							});
						} else{
							laptapListWrap.show();
							
							isLaptap.find('.product-list-top').css({
								"top": m_nav_h + opt_list_h + "px"
							});
						}

						// 활성화된 옵션 X 버튼 클릭으로 인해 활성화된 옵션이 0개일 경우 / reset 버튼 클릭 event
						isLaptap.find('.s-fliter .btn-del, .laptap-opt-list-wrap .item-reset').on('click', function(){
							if( isLaptap.find('.opt-list > li').length == 0 ) {
								isLaptap.find('.product-list-top').css({
									"top": m_nav_h + "px"
								});
							}
						})
					} else {
						// 체크된 옵션이 없는 경우
						if( laptapList.find('.opt-list >li').length == 0 ){
							laptapListWrap.hide();

							isLaptap.find('.product-list-top').css({
								"top": nav_tab_h + "px"
							});
						} else{
							laptapListWrap.show();
							
							isLaptap.find('.product-list-top').css({
								"top": nav_tab_h + opt_list_h + "px"
							});
						}

						// 활성화된 옵션 X 버튼 클릭으로 인해 활성화된 옵션이 0개일 경우 / reset 버튼 클릭 event
						isLaptap.find('.s-fliter .btn-del, .laptap-opt-list-wrap .item-reset').on('click', function(){
							if( isLaptap.find('.opt-list > li').length == 0 ) {
								isLaptap.find('.product-list-top').css({
									"top": nav_tab_h + "px"
								});
							}
						})
					}
				}
				last_scrollTop = tmp;
			} else if( isLaptap.find('.cate-wrap').hasClass('fixed') === false ){
				isLaptap.find('.product-list-top').removeAttr("style");

				// 활성화된 옵션 X 버튼 클릭으로 인해 활성화된 옵션이 0개일 경우 / reset 버튼 클릭 event
				isLaptap.find('.s-fliter .btn-del, .laptap-opt-list-wrap .item-reset').on('click', function(){
					if( isLaptap.find('.cate-wrap').hasClass('fixed') === false ){
						isLaptap.find('.product-list-top').removeAttr("style");
					}
				})
				
				/* BTOCSITE-63911 멀티필터일 경우 스크롤 업 시 보이도록 시작 */
				if( isLaptap.find('.plp-afilter-choice').height() > 100 ) {
					isLaptap.find('.plp-afilter-choice').show();
				}
				/* BTOCSITE-63911 멀티필터일 경우 스크롤 업 시 보이도록 끝 */
			}
		} else{
			isLaptap.find('.product-list-top').removeAttr("style");
		}
	}

	isLaptap.find('.btn-afilter').on('click', function(){
		isLaptap.find('.product-list-top').css("opacity", 0);
		setTimeout(function(){
			isLaptap.find('.product-list-top').removeAttr("style");
		},300)
	})

	$(window).scroll(function() {
		filterScrollDirectionCheck();
	});
}

$(function() {
	var bizType = $('.hidden-input-group input[name=bizType]').val();
	//var subCategoryId = $('.hidden-input-group input[name=subCategoryId]').val();
	var lineupId = $('.hidden-input-group input[name=lineupId]').val();
	//BTOCSITE-61716 모바일 전체 탭 클릭시 앵커 이동안함(subCategoryId가 ''일때도 앵커이동하도록 변경하니 노트북 하위 뎁스에서도 엥커 이동해서 lineupId가 있을때는 앵커 이동 안하도록 함.) 
	//if ((bizType === 'PRODUCT' || bizType === 'CARESOLUTION') && subCategoryId !== '') {
	if ((bizType === 'PRODUCT' || bizType === 'CARESOLUTION') && lineupId == '') {	
		//PLP 진입 시 자동 스크롤 기능 제거
		//goScrollToProductList();
	}
});